import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { getBrands } from '../../../../api/brand/queries/getBrands';
import { IBrand } from '../../../../interfaces/Brand.interfaces';

interface IUseGetBrandsQueryParams {
  options?: UseQueryOptions<IBrand[], AxiosError>;
}

export const useGetBrandsQuery = (params?: IUseGetBrandsQueryParams) => {
  return useQuery<IBrand[], AxiosError>(['brands'], getBrands, {
    ...params?.options,
    select: (brands) => {
      const orderedBrandsByImportance = [
        '존디어',
        '뉴홀랜드',
        '구보다',
        '얀마',
        '대동',
        'TYM(국제)',
        'TYM(동양)',
        'LS',
      ];

      const sortedBrands = brands.sort((a, b) => {
        const indexA = orderedBrandsByImportance.indexOf(a.name);
        const indexB = orderedBrandsByImportance.indexOf(b.name);

        if (indexA !== -1 && indexB !== -1) {
          return indexA - indexB;
        }

        if (indexA !== -1) {
          return -1;
        }

        if (indexB !== -1) {
          return 1;
        }

        return a.name.localeCompare(b.name);
      });

      return sortedBrands;
    },
  });
};
